"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
var Validator = /** @class */ (function () {
    function Validator() {
    }
    Validator.setSpecs = function (specs) {
        Validator.specs = specs;
    };
    Validator.getSpecs = function () {
        return Validator.specs;
    };
    Validator.hasSpecs = function () {
        return Validator.specs && Validator.specs.length > 0 ? true : false;
    };
    Validator.flushSpecs = function () {
        this.specs = [];
    };
    Validator.buildSpecKey = function (productType, productCode, state) {
        return state ? productType + '_' + productCode + '_' + state : productType + '_' + productCode;
    };
    Validator.findSpecObject = function (specKey) {
        var _a;
        return (_a = Validator.specs) === null || _a === void 0 ? void 0 : _a.filter(function (spec) { return spec.hierarchy === specKey; })[0];
    };
    Validator.fetchSpecObjectFromSpecs = function (productType, productCode, state) {
        var key = Validator.buildSpecKey(productType, productCode, state);
        var specObj = Validator.findSpecObject(key);
        return specObj ? specObj : Validator.findSpecObject(Validator.buildSpecKey(productType, productCode));
    };
    return Validator;
}());
exports.Validator = Validator;
